import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const COLUMNS = [
  "Brand Name",
  "Date",
  "Click Out",
  "FTD (%CVR)",
  "QFTD (%CVR)",
  "CPA Income",
  "RS Income",
  "Total Income",
  "Total Income $",
  "NetRev",
  "EPC",
  "ROI",
  "PV",
];

interface AnomaliesSkeletonProps {
  rows?: number;
}

const AnomaliesSkeleton = ({ rows = 10 }: AnomaliesSkeletonProps) => {
  return (
    <Paper sx={{ p: 2 }}>
      {/* Header: title + brand search + download icon */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Skeleton variant="text" width={220} height={32} />
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Skeleton variant="rounded" width={260} height={40} />
          <Skeleton variant="circular" width={28} height={28} />
        </Box>
      </Box>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {COLUMNS.map((col) => (
                <TableCell key={col}>{col}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {COLUMNS.map((col) => (
                  <TableCell key={col}>
                    <Skeleton variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination footer */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 2,
          mt: 1.5,
        }}
      >
        <Skeleton variant="text" width={120} />
        <Skeleton variant="rounded" width={160} height={28} />
      </Box>
    </Paper>
  );
};

export default AnomaliesSkeleton;
